module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House70.3f1a3ccf.jpg";